import React from 'react';

interface OwnProps {
    color: string;
}

const PaperIcon = ({ color }: OwnProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
            <path
                d="M7.83464 1.5127V4.26639C7.83464 4.63976 7.83464 4.82644 7.9073 4.96905C7.97121 5.09449 8.0732 5.19648 8.19864 5.26039C8.34125 5.33306 8.52793 5.33306 8.9013 5.33306H11.655M9.16797 8.66634H3.83464M9.16797 11.333H3.83464M5.16797 5.99967H3.83464M7.83464 1.33301H4.36797C3.24786 1.33301 2.68781 1.33301 2.25999 1.55099C1.88366 1.74274 1.5777 2.0487 1.38596 2.42503C1.16797 2.85285 1.16797 3.4129 1.16797 4.53301V11.4663C1.16797 12.5864 1.16797 13.1465 1.38596 13.5743C1.5777 13.9506 1.88366 14.2566 2.25999 14.4484C2.68781 14.6663 3.24786 14.6663 4.36797 14.6663H8.63463C9.75474 14.6663 10.3148 14.6663 10.7426 14.4484C11.1189 14.2566 11.4249 13.9506 11.6166 13.5743C11.8346 13.1465 11.8346 12.5864 11.8346 11.4663V5.33301L7.83464 1.33301Z"
                stroke={color ?? color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PaperIcon;
